/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Layers, SerialLayers} from "../../../view/SerialLayers";
import {gsap} from "gsap";
import {Serial} from "../../../Serial";

export class BigWinView {

    private _layer:StageLayer;
    private _backContainer:PIXI.Container;
    private _middleContainer:PIXI.Container;
    private _frontContainer:PIXI.Container;
    private _levelAnimations:PIXI.spine.Spine[] = [];
    private _frontEffects:PIXI.spine.Spine;
    private _dimmer:PIXI.Graphics;
    private _l4Censor:PIXI.Sprite;

    constructor() {
        this._layer = SerialLayers.getLayer(Layers.BIG_WIN)!;

        this._dimmer = new PIXI.Graphics();
        this._dimmer.beginFill(0x000000, 1);
        this._dimmer.drawRect(-840, -840, 1680, 1680);
        this._dimmer.endFill();
        this._dimmer.alpha = 0;
        this._dimmer.position.set(360, 360);
        this._layer.addChild(this._dimmer);

        this._backContainer = new PIXI.Container();
        this._middleContainer = new PIXI.Container();
        this._frontContainer = new PIXI.Container();
        this._layer.addChild(this._backContainer, this._middleContainer, this._frontContainer);
    }

    public getLevelAnimation(level:number, duration:number, isEndLevel:boolean):gsap.core.Timeline {
        const tl = gsap.timeline();
        let levelAnimation:PIXI.spine.Spine;
        if(!this._levelAnimations[level]) {
            levelAnimation = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset(`bigWinL${level + 1}`));
            levelAnimation.autoUpdate = true;
            levelAnimation.position.set(360, 360);
            if(level === 3) {
                levelAnimation.state.timeScale = 0.6;
            }
            this._levelAnimations[level] = levelAnimation;
        } else {
            levelAnimation = this._levelAnimations[level];
        }
        if(level === 3 && !this._l4Censor) {
            this._l4Censor = new PIXI.Sprite(Serial.assetLoader.getTextures("bigwinsequence4/redMask")[0]);
            this._l4Censor.anchor.set(0.5, 0.5);
            this._l4Censor.position.set(356, 374);
        }
        // if(!this._frontEffects) {
        //     this._frontEffects = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset(`bigWinFx`));
        //     this._frontEffects.autoUpdate = true;
        //     this._frontEffects.position.set(360, 360);
        // }
        tl.add(() => {
            levelAnimation.state.setAnimation(0, "Loop", true);
            levelAnimation.alpha = 1;
            this._middleContainer.addChild(levelAnimation);
            if(level === 3) {
                this._l4Censor.alpha = 1;
                this._frontContainer.addChild(this._l4Censor);
            }
            // this._frontEffects.state.setAnimation(0, `BigWinSequence${level + 1}`, true);
            // this._frontContainer.addChild(this._frontEffects);
            gsap.to(this._dimmer, {alpha : 0.8, duration : 0.5});
        }, 0);
        tl.add(() => {
            gsap.to(levelAnimation, {
                duration : 0.5, alpha : 0, onComplete : () => {
                    levelAnimation.state.clearTrack(0);
                    levelAnimation.skeleton.setToSetupPose();
                    levelAnimation.state.setEmptyAnimation(0, 0);
                    levelAnimation.parent.removeChild(levelAnimation);
                    // this._frontEffects.state.clearTrack(0);
                    // this._frontEffects.skeleton.setToSetupPose();
                    // this._frontEffects.state.setEmptyAnimation(0, 0);
                    // this._frontEffects.parent.removeChild(levelAnimation);

                }
            });
            if(this._l4Censor && this._l4Censor.parent) {
                gsap.to(this._l4Censor, {
                    duration : 0.5, alpha : 0, onComplete : () => {
                        if(this._l4Censor && this._l4Censor.parent) {
                            this._l4Censor.parent.removeChild(this._l4Censor);
                            this._l4Censor.alpha = 1;
                        }
                    }
                })
            }
        }, duration);

        return tl;
    }

    public playEnding(endLevel:number):void {
        gsap.to(this._dimmer, {alpha : 0, duration : 0.5});
        // TODO:
    }
}